import ModelPopup from "../../helpers/ModelPopup";
import IssueCardBody from "./IssueCardBody";
import { Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import IssuePhysicalCardBody from "./IssuePhysicalCardBody";

const IssuePhysicalCard = (props) => {
  const { user: currentUser } = useSelector((state) => state.auth);

  if (!currentUser) {
    return <Redirect to="/login" />;
  }
  return (
    <ModelPopup
      show={props.show}
      onHide={props.onHide}
      modelheading={""}
      showheader={"false"}
      className="smallPopup issueCardSmall"
      dialogClassName="modal-dialog modal-dialog-centered mwidth-76"
      backdrop="static"
      keyboard={false}
      modelbody={<IssuePhysicalCardBody show={props.show} onHide={props.onHide} />}
    />
  );
};

export default IssuePhysicalCard;
